__turbopack_context__.v({
  "addAsset": "inputForm-module-scss-module__9yEALG__addAsset",
  "buttonWrapper": "inputForm-module-scss-module__9yEALG__buttonWrapper",
  "caption": "inputForm-module-scss-module__9yEALG__caption",
  "controlNumberInput": "inputForm-module-scss-module__9yEALG__controlNumberInput",
  "desc": "inputForm-module-scss-module__9yEALG__desc",
  "form": "inputForm-module-scss-module__9yEALG__form",
  "noAmount": "inputForm-module-scss-module__9yEALG__noAmount",
  "priceButton": "inputForm-module-scss-module__9yEALG__priceButton",
  "wrapper": "inputForm-module-scss-module__9yEALG__wrapper",
  "yellow": "inputForm-module-scss-module__9yEALG__yellow",
});
